import {
    baseConfig, default_location_config,
    headerLinks
} from "../constants";
import { RootConfigType } from "../constantsTyped";
import { MANGO_FRUIT } from "../fruitNames";


export const SHPTropicalConfig: RootConfigType = {
    ...baseConfig,
    default_fruit_type: MANGO_FRUIT,
    can_do_manual_check: true,
    default_location_config: { ...default_location_config, device_result_action: false },
    default_manual: true,
    indicate_soft_avocado_at_internal: false,
    suggest_color_stage: true,

    default_location: "ripening",

    research_mode: false,
    invalidate_20x_firmness: false,
    headerMainLinks: [headerLinks.home, headerLinks.packinglist],
    headerSecondaryLinks: [headerLinks.packinglist, headerLinks.settings, headerLinks.logout],
};
